import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HomeRouteService, SessionService } from '../services';

/**
 * The sign in page owns the root url, so it would render while an expired token is still
 * being refreshed. Resolving the session here keeps it out of the way until we know the
 * user really has to log in again.
 */
export const signInRedirectGuard: CanActivateFn = async () => {
  const session = inject(SessionService);
  const router = inject(Router);
  const homeRouteService = inject(HomeRouteService);

  if (!(await session.restore())) return true;

  return router.createUrlTree([await homeRouteService.getHomeRoute()]);
};
